<script setup lang="ts">
import { router } from "@inertiajs/vue3"
import type { DropdownMenuItem } from "@nuxt/ui"
import { computed } from "vue"

import NinjanizrMark from "@/assets/mark.svg?component"
import { useAccounts } from "@/composables/useAccounts"
import { ICON } from "@/lib/icons"
import { accountPath } from "@/routes"

defineProps<{ collapsed?: boolean }>()

const { currentAccount, accounts, canSwitch } = useAccounts()

const menuItems = computed<DropdownMenuItem[][]>(() => [
  accounts.value.map((account) => ({
    label: account.name,
    onSelect: () => router.patch(accountPath(account.id)),
  })),
])
</script>

<template>
  <template v-if="currentAccount">
    <div v-if="!canSwitch" class="flex min-w-0 items-center gap-2 px-1 py-1">
      <NinjanizrMark class="size-8 shrink-0" />
      <span v-if="!collapsed" class="text-highlighted truncate text-sm font-semibold">
        {{ currentAccount.name }}
      </span>
    </div>

    <UDropdownMenu
      v-else
      :items="menuItems"
      :content="{ align: 'start', collisionPadding: 12 }"
      :ui="{ content: 'w-(--reka-dropdown-menu-trigger-width) min-w-56' }"
    >
      <UButton
        color="neutral"
        variant="ghost"
        block
        :square="collapsed"
        class="data-[state=open]:bg-elevated"
        :aria-label="`Switch inventory. Current inventory: ${currentAccount.name}`"
      >
        <NinjanizrMark class="size-8 shrink-0" />
        <template v-if="!collapsed">
          <span class="flex min-w-0 flex-1 flex-col text-left leading-tight">
            <span class="text-dimmed text-[10.5px] font-semibold tracking-wide uppercase">
              Inventory
            </span>
            <span class="text-highlighted truncate text-sm font-semibold">
              {{ currentAccount.name }}
            </span>
          </span>
          <UIcon :name="ICON.chevronUpDown" class="text-dimmed size-4 shrink-0" />
        </template>
      </UButton>
    </UDropdownMenu>
  </template>
</template>
